import {
    FETCH_COUPONS,
} from "constants/ActionTypes";

const INIT_STATE = [];

 export default (state = INIT_STATE , action) => {
    switch(action.type) {
        case FETCH_COUPONS : {
            if (action.payload == undefined || action.payload == []) {
                return state;
            } else {
                const newState = action.payload.map( (value) => {
                    return value
                });
                return newState;
            }
        } ;
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/appRedux/reducers/Coupons.js